export default __webpack_public_path__ + "bfc9146cbd68197fbbffb1f4d04a5982.svg";